import { render, staticRenderFns } from "./ReporteVentasGlobalLibros.vue?vue&type=template&id=2648d0d1&scoped=true"
import script from "./ReporteVentasGlobalLibros.vue?vue&type=script&lang=js"
export * from "./ReporteVentasGlobalLibros.vue?vue&type=script&lang=js"
import style0 from "./ReporteVentasGlobalLibros.vue?vue&type=style&index=0&id=2648d0d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2648d0d1",
  null
  
)

export default component.exports